import React from "react";
import SEOHead from "../components/SEOHead";
import { Link, useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

function AIInterviewCoach() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      <SEOHead
        title="AI Interview Coach"
        description="Practice job interviews with AI. Get real-time feedback, improve answers, and land your next job faster with EmployPilot."
        canonical="https://employpilot.com/ai-interview-coach"
      />
  

      {/* HERO */}
      <h1>AI Interview Coach That Helps You Land the Job</h1>

      <p style={{ fontSize: "18px", color: "#555" }}>
        Practice real interview questions with AI. Improve your answers, gain
        confidence, and prepare for any job interview.
      </p>

      {/* 🔥 PRIMARY CTA */}
      <button onClick={handleStart} style={btnPrimary}>
        Start Practicing Free
      </button>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>Why Use an AI Interview Coach?</h2>

      <ul>
        <li>✔ Real-time interview feedback</li>
        <li>✔ Industry-specific questions</li>
        <li>✔ Confidence building</li>
        <li>✔ Faster job preparation</li>
      </ul>

      {/* SECTION */}
      <h2 style={{ marginTop: "40px" }}>How It Works</h2>

      <ol>
        <li>Select your job role</li>
        <li>Answer AI-generated questions</li>
        <li>Receive feedback instantly</li>
        <li>Improve and retry</li>
      </ol>

      {/* INTERNAL SEO LINKS */}
      <p style={{ marginTop: "20px" }}>
        Need a resume first?{" "}
        <Link to="/ai-resume-builder">
          Build your resume here
        </Link>
      </p>

      {/* 🔥 CONVERSION EXIT (CRITICAL FIX) */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Preparing for Your Next Interview</h2>

        <p>
          Create your free account and begin practicing with structured guidance.
        </p>

        <button onClick={handleStart} style={btnSuccess}>
          Get Started Free
        </button>
      </div>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  marginTop: "20px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer"
};

export default AIInterviewCoach;